import { createAsyncThunk } from "@reduxjs/toolkit";

import { 
  getArtistWinRewards as getArtistWinRewardsApi,
  addRewards as addRewardsApi,
  getRewardDetails as getRewardDetailsApi

 } from "../../helpers/custom_helper/backend_helper";


 export const getAllArtistRewardsThunk = createAsyncThunk("get-artist-rewards", async (postData) => {
  try {
   
     const response = getArtistWinRewardsApi(postData);
     const data = await response;
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});
 export const addRewardThunk = createAsyncThunk("add-reward", async (postData) => {
  try {
   
     const response = addRewardsApi(postData);
     const data = await response;
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});
 export const getRewardDetailsThunk = createAsyncThunk("get-reward-details", async (postData) => {
  try {
   
     const response = getRewardDetailsApi(postData);
     const data = await response;
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});













